/* template */
<template><div :data-mall-theme="(theme)" class="coupon-wrap"><div :class="({ isEn:isEn})" :style="(couponStyleConf.couponStyle)" class="coupon-icon"><mpx-image :src="(descTipsImg)" mode="widthFix" class="desc-tip-img" v-if="(descTipsImg)"></mpx-image><div class="coupon-content coupon-content-1"><div class="coupon-icon-text"><special-text :text="(couponAmount)" :rules="(hightLghtRules)" class="coupon-amount"></special-text><mpx-image src="https://ut-static.udache.com/webx/fe-agility-wyc/V-YUklqRsiTphrkeaaNGI.png" class="cheng"></mpx-image><div class="coupon-count"><special-text :style="(couponStyleConf.unitStyle)" :text="(couponNumber)" :rules="(hightLghtRules)"></special-text><div class="is-free" v-if="(freeText)">{{freeText}}</div></div></div><span :style="(couponStyleConf.capStyle)" class="cap">{{capText}}</span></div></div><mpx-view @tap="arrowClick" class="coupon-desc"><div class="desc-box"><app-html :class='("desc-text "+(showDesc ? "show" : "hide"))' ref="descText" :html="(descText)"></app-html><div :class='("desc-arrow "+(showDesc ? "show" : "hide"))' v-if="(showArrow)"></div></div></mpx-view></div></template>

/* styles */
<style lang="scss" scoped mpxStyleOptions='{"mid":"m0bbcbfd7"}'>
.coupon-wrap .car-wrap .car-type{
   /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /*! autoprefixer: on */
}
.coupon-wrap .car-wrap .time-limit{

   /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /*! autoprefixer: on */
}
</style>
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0bbcbfd7"}'>
@import "../../../lib/stylus/variable.styl"
// @import './theme.styl'

.coupon-wrap
  display flex
  flex-direction column
  align-items center
  .coupon-icon
    width 670rpx
    height 168rpx
    box-sizing border-box
    background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/XOydEVFqxNjReJkymTptW.png')
    background-size: contain
    background-position: center
    background-repeat: no-repeat
    position relative
    display flex
    z-index 1
    .desc-tip-img
      position absolute
      top 0
      left 0
      height 44rpx !important
      width auto
    &.isEn
      .coupon-icon-text
        padding-top 0rpx
        font-size 64rpx!important
      .cap
        font-size 18rpx!important
        line-height 25rpx
    .coupon-content
      width 580rpx
      height 100%
      display flex
      flex-direction column
      align-items center
      justify-content center
    .coupon-icon-text
      display flex
      justify-content center
      align-items flex-end
      white-space nowrap
      margin-top -17rpx
      .coupon-count,
      .coupon-amount
        font-weight: $fw-medium;
        font-size: 32rpx;
        letter-spacing: 0;
        text-align: center;
        text-shadow: 0 0 2rpx #FFFFFF;
        &.symbol
          font-size: 32rpx!important
      .coupon-amount
        color #000000
      .coupon-count
        position relative
        color #FF6835
      .is-free
        position absolute
        top 8rpx
        right calc(-100% - 12rpx)
        height 32rpx
        padding 0 16rpx
        background-image linear-gradient(90deg, #FE593F 0%, #FE1100 100%)
        border-radius 40rpx 32rpx 32rpx 0
        line-height 32rpx
        font-family: PingFangSC-Medium;
        font-size: 24rpx;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 500;
      .cheng
        width 21rpx
        height 21rpx
        margin 0 22rpx 14rpx 20rpx
    .cap
      display flex
      white-space nowrap
      justify-content center
      align-items center
      font-size 22rpx
      line-height 30rpx
      margin-top 4rpx
      padding 0 20rpx
      color rgba(79,39,25,0.80)
      opacity 0.6
      letter-spacing 0
      text-align center
      white-space pre-wrap
  .coupon-desc
    position relative
    margin-top -44rpx
    width 670rpx
    min-height 98rpx
    background: rgba(240,242,247,0.40);
    border-radius: 20rpx;
    text-align center
    font-size 22rpx
    color rgba(54,72,107,0.60)
    line-height 32rpx
    font-weight $fw-medium
    .desc-box
      position relative
      margin-top 52rpx
      padding-bottom 14rpx
      display flex
      align-items center
      justify-content center
    .desc-text
      display flex
      margin 0 65rpx
      &.show
        overflow: visible;
        -webkit-line-clamp: unset;
      &.hide
        height 32rpx
        word-wrap:break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /* autoprefixer: ignore next */
        -webkit-box-orient: vertical;
    .desc-arrow
      position absolute
      right 16rpx
      width 40rpx
      height 40rpx
      background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/Nspw-jpeiC21JLaOmrOia.png')
      background-size 14rpx 14rpx
      background-position: center
      background-repeat: no-repeat
      transition transform 0.3s ease
      &.show
        transform rotate(180deg)
      &.hide
        transform rotate(0)

theme()
</style>
<style lang="stylus" mpxStyleOptions='{"mid":"m0bbcbfd7"}'>
.check-detail-list
  .car-type
    // div
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    span
      color #979797
      opacity 0.34
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { ComponentsMixin } from '../../../lib/webx/mpx/mixins/page_detail/component'
import { EnumCouponType, EnumLang, EnumProductID } from '../../../lib/webx/defines/enums.js'
import { GlobalEnv } from '../../../lib/webx/global_env/index.js'
import { getCurrencyText } from '../../../lib/js/util'
import { rpx } from '../../../lib/webx/utils/format'
import { STYLE_BY_PRODUCT_TYPE } from '../../../lib/webx/config/prod_config'
import { utils } from '@didi/webx-js'

createComponent({
  mixins: [ ComponentsMixin ],
  data() {
    return {
      showDesc: true,
      showArrow: false,
      hightLghtRules: {
        '{x}': {
          style: Object.entries({
            position: 'relative',
            top: rpx('5rpx'),
            left: 0,
            // 'color': '#FF6835',
            'font-family': 'Barlow-Bold',
            'font-size': rpx('64rpx'),
            margin: `0 ${rpx('4rpx')}`,
          }).map(([ key, value ]) => `${key}: ${value}`).join(';'),
        },
      },
    }
  },
  properties: {
    item: {
      type: Object,
      value: () => {},
    },
    currency: String,
    productType: [ Number, String ],
  },
  computed: {
    isDiscount() {
      return this.item.discountType === EnumCouponType.Discount || this.item.discountType === EnumCouponType.DiscountEst
    },
    capText() {
      return this.item.capTextV2
    },
    valueUnit() {
      if (this.item.discountType === EnumCouponType.RentFree) {
        return '天免租'
      }
      // TODO 封顶券不投放英港，后期投放时，记得让产品申请翻译文案
      if (this.item.discountType === EnumCouponType.Cap) {
        return `${getCurrencyText(this.currency)}${this.$t('common.capText')}`
      }
      return this.isDiscount ? this.$t('common.discount') : getCurrencyText(this.currency)
    },
    isEn() {
      return GlobalEnv.lang === EnumLang['en-US']
    },
    numFixed() {
      let rst = ''
      if (this.item.discountType === EnumCouponType.SwellCount || this.item.discountType === EnumCouponType.Reduction || this.item.discountType === EnumCouponType.FixedPrice || this.item.discountType === EnumCouponType.Cap) {
        if (!(this.item.discountAmount % 100)) {
          rst = this.item.discountAmount / 100
        } else {
          rst = (this.item.discountAmount / 100).toFixed(1)
        }
      } else if (this.item.discountType === EnumCouponType.Discount || this.item.discountType === EnumCouponType.DiscountEst) {
        if (!this.isEn) {
          if (!(this.item.discount % 10)) {
            rst = this.item.discount / 10
          } else {
            rst = (this.item.discount / 10).toFixed(1)
          }
        } else {
          // 英文特殊处理
          const off = 100 - this.item.discount
          rst = `${off}%`
        }
      } else if (this.item.discountType === EnumCouponType.RentFree) {
        rst = this.item.rentFreeDays
      }
      return rst
    },
    isRight() {
      return Number(this.item.productId) === EnumProductID.Rights
    },
    couponAmount() {
      if(this.isRight) {
        return this.item.name
      }
      if (this.item.discountType === EnumCouponType.FixedPrice) {
        return this.item.productDesc
      }
      return `{${this.numFixed}}${this.valueUnit}`
    },
    couponNumber() {
      if(this.isRight) {
        return `{${this.item.couponNumber}}个`
      }
      return `{${this.item.couponNumber}}${this.$t('goodsDetail.num')}`
    },
    freeText() {
      if (this.isRight && this.item.isFree) {
        return this.$t('home.sendText')
      }
      return ''
    },
    duration() {
      if (
        this.item.duration
      ) {
        return this.item.duration.join(' , ')
      }
      return ''
    },
    descText() {
      const couponInfo = this.item || {}
      const _result = []
      if (couponInfo.carTypeAll) {
        _result.push(couponInfo.carTypeAll)
      }
      const durationDay = couponInfo.durationDay || this.$t('goodsDetail.noTimeLimit')
      _result.push(durationDay)
      if (this.duration) {
        _result.push(this.duration)
      }
      if (couponInfo.sceneText) {
        _result.push(couponInfo.sceneText)
      }
      return _result.join(' | ')
    },
    descTipsImg() {
      return this.item?.ruleTipsUrl
    },
    couponStyleConf() {
      const prodStyleInfo = STYLE_BY_PRODUCT_TYPE[Number(this.productType)]?.coupon_style || STYLE_BY_PRODUCT_TYPE[0]?.coupon_style
      if (!Object.keys(prodStyleInfo)?.length) return {}
      return {
        couponStyle: {
          backgroundImage: `url(${utils.webpUrl(prodStyleInfo.background_image)})`,
        },
        unitStyle: {
          color: prodStyleInfo.unit_color,
        },
        capStyle: {
          color: prodStyleInfo.cap_color,
        },
      }
    },
  },
  attached() {
    setTimeout(() => {
      const el = this.$refs.descText?.$el || {}
      if (el.scrollHeight > 25) {
        this.showArrow = true
      }
    }, 200)
  },
  methods: {
    arrowClick() {
      this.showDesc = !this.showDesc
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "coupon-package0bbcbfd7",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'app-html':getComponent(require("../../common/rich-text.mpx?component=true&componentId=rich-text723effcf")),'special-text':getComponent(require("../../../../node_modules/@didi/mpx-ui/src/components/special-text/index.mpx?component=true&componentId=index8d2b07c0")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
